import { render } from "./apply.html?vue&type=template&id=fb712b2c&scoped=true&ts=true"
import script from "./apply.ts?vue&type=script&lang=ts"
export * from "./apply.ts?vue&type=script&lang=ts"

import "./apply.scss?vue&type=style&index=0&id=fb712b2c&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb712b2c"]])

export default __exports__